export default "__VITE_ASSET__DPHdA6po__"